"use client";
import { useState as i, useEffect as n, useCallback as r } from "react";
function o() {
  const [e, t] = i(!1);
  n(() => {
    if (e) {
      const a = setTimeout(() => t(!1), 0);
      return () => clearTimeout(a);
    }
  }, [e]);
  const s = r(() => t(!0), []);
  return { disabled: e, disableTransition: s };
}
export {
  o as useInstantUpdate
};
